import moment from 'moment';

export function dateRangeTodayUntilEnd() {
  const today = moment.utc().local();
  return [
    today.startOf("day").toDate(),
    today.endOf("day").toDate(),
  ];
}